import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Call } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

import * as memberActions from "redux/member/action";
//import useFetch from "lib/useFetch";
//import { API_URL } from "modules/configApp";
import { LOGO, PHOME } from 'modules/configApp'

import * as yup from "yup";

//import { yupResolver } from '@hookform/resolvers'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    //backgroundColor: "#fff",
    background: "transparent",
    border: "1px",
  },
  rootLoading: {
    zIndex: 10,
    top: 150,
    position: "absolute",
  },
  media: {
    height: 140,
    background: "transparent",
    //backgroundColor: "#bd0000",

    /* Center and scale the image nicely */
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    width: "100%",
    backgroundColor: "#000",
    height: 35,
    fontSize: 16,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderColor: "#b88c3b",
    textAlign: "center",
    color: "#b88c3b",
  },
  formControl: {
    marginTop: theme.spacing(1),
    minWidth: "100%",
  },
  rootbtn: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  headerform: {
    color: "#b88c3b",
  },
}));

export default function MediaCard(props) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { register, handleSubmit, errors } = useForm({
    mode: "onBlur",
    validationSchema: yup.object().shape({
      UserName: yup.string().required(),
    }),
    //validationSchema:
    /*
    validationSchema:yup.object.shape({
      UserName:yup.string().required(),
      password:yup.string().required()
    })
    */
  });

  /*
  const { register, handleSubmit , errors} = useForm()
*/
  const submit = ({ UserName }) => {
    const dataSave = {
      UserName,
    };

    const action = memberActions.ForgotPassword({ ...dataSave, ...props });
    dispatch(action);
  };

  useEffect(() => {}, []);
  const dispatch = useDispatch();
  const { isLoading, message, datanotify } = useSelector(
    (store) => store.member
  );

  const goBack = () => {
    history.push("/signin");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    const action = memberActions.GetList();
    dispatch(action);
  };

  const submit2 = () => {
    btnSubmit.current.click();
  };
  const btnSubmit = React.useRef(null);

  return (
    <>
      <div style={{ height: 125, paddingTop:7 }}>
        <img src={PHOME.logohome} height={135}></img>
      </div>
      <Container
        maxWidth="md"
        style={{
          paddingTop: 20,
          display: "flex",
          flexDirection: "row",
          justifyContent: "left",
        }}
      >
        <Button
          color="primary"
          startIcon={<ArrowBackIosIcon />}
          variant="outlined"
          onClick={() => goBack()}
          className="btnback"
        >
          ຍ້ອນກັບ
        </Button>
      </Container>
      <div style={{ height: 20 }}></div>
      <Container
        maxWidth="sm"
        style={{
          paddingTop: 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div className="bgconh1">
          <Typography
            gutterBottom
            variant="h5"
            component="h3"
            className="headtitle"
          >
            ລືມລະຫັດຜ່ານ ?
          </Typography>
          <div style={{ height: 20 }}></div>
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(submit)}
          >
            {/*
 <input
                placeholder="กรอกเบอร์มือถือ (ไม่ต้องใส่ -)"
                className={classes.input}
              ></input>
                */}

            <input
              ref={register}
              type="text"
              id="username"
              name="UserName"
              class="form__input"
              placeholder="ຜົນລາງວັນ (ຫ້າມເຂົ້າ -)"
              autocomplete="off"
              //value={credit ? credit : null}
              //onChange={setCreditNew2}
            />
            <div style={{ height: 20 }}></div>

            {message === 3 && (
              <Alert variant="outlined" severity="error">
                ข้อมูลสมาชิกไม่ถูกต้อง กรุณาป้อนใหม่อีกครั้ง !!
              </Alert>
            )}

            <div className="btnsubmit" onClick={submit2}>
            ຮ້ອງຂໍລະຫັດຜ່ານໃຫມ່
            </div>

            <button type="submit" ref={btnSubmit} className="btnnone"></button>
          </form>
        </div>
        {isLoading && (
          <div className={classes.rootLoading}>
            <CircularProgress color="secondary" />
          </div>
        )}
      </Container>
      <Snackbar
        open={datanotify.show}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
        ບໍ່ພົບຂໍ້ມູນສະມາຊິກ.
        </Alert>
      </Snackbar>
    </>
  );
}
